var _excluded = ["messages", "agentId"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AbstractChat } from 'ai';
export { AbstractChat };
export var CACHE_KEY = 'instantsearch-chat-initial-messages-';
function getDefaultInitialMessages(id) {
  var initialMessages = sessionStorage.getItem(CACHE_KEY + id);
  return initialMessages ? JSON.parse(initialMessages) : [];
}
export var ChatState = /*#__PURE__*/function () {
  function ChatState() {
    var _this = this;
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var initialMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getDefaultInitialMessages(id);
    _classCallCheck(this, ChatState);
    _defineProperty(this, "_messages", void 0);
    _defineProperty(this, "_status", 'ready');
    _defineProperty(this, "_error", undefined);
    _defineProperty(this, "_messagesCallbacks", new Set());
    _defineProperty(this, "_statusCallbacks", new Set());
    _defineProperty(this, "_errorCallbacks", new Set());
    _defineProperty(this, "pushMessage", function (message) {
      _this._messages = _this._messages.concat(message);
      _this._callMessagesCallbacks();
    });
    _defineProperty(this, "popMessage", function () {
      _this._messages = _this._messages.slice(0, -1);
      _this._callMessagesCallbacks();
    });
    _defineProperty(this, "replaceMessage", function (index, message) {
      _this._messages = [].concat(_toConsumableArray(_this._messages.slice(0, index)), [
      // We deep clone the message here to ensure the new React Compiler (currently in RC) detects deeply nested parts/metadata changes:
      _this.snapshot(message)], _toConsumableArray(_this._messages.slice(index + 1)));
      _this._callMessagesCallbacks();
    });
    _defineProperty(this, "snapshot", function (thing) {
      return JSON.parse(JSON.stringify(thing));
    });
    _defineProperty(this, '~registerMessagesCallback', function (onChange) {
      var callback = onChange;
      _this._messagesCallbacks.add(callback);
      return function () {
        _this._messagesCallbacks.delete(callback);
      };
    });
    _defineProperty(this, '~registerStatusCallback', function (onChange) {
      _this._statusCallbacks.add(onChange);
      return function () {
        _this._statusCallbacks.delete(onChange);
      };
    });
    _defineProperty(this, '~registerErrorCallback', function (onChange) {
      _this._errorCallbacks.add(onChange);
      return function () {
        _this._errorCallbacks.delete(onChange);
      };
    });
    _defineProperty(this, "_callMessagesCallbacks", function () {
      _this._messagesCallbacks.forEach(function (callback) {
        return callback();
      });
    });
    _defineProperty(this, "_callStatusCallbacks", function () {
      _this._statusCallbacks.forEach(function (callback) {
        return callback();
      });
    });
    _defineProperty(this, "_callErrorCallbacks", function () {
      _this._errorCallbacks.forEach(function (callback) {
        return callback();
      });
    });
    this._messages = initialMessages;
    var saveMessagesInLocalStorage = function saveMessagesInLocalStorage() {
      if (_this.status === 'ready') {
        try {
          sessionStorage.setItem(CACHE_KEY + id, JSON.stringify(_this.messages));
        } catch (e) {
          // Do nothing if sessionStorage is not available or full
        }
      }
    };
    this['~registerMessagesCallback'](saveMessagesInLocalStorage);
    this['~registerStatusCallback'](saveMessagesInLocalStorage);
  }
  _createClass(ChatState, [{
    key: "status",
    get: function get() {
      return this._status;
    },
    set: function set(newStatus) {
      this._status = newStatus;
      this._callStatusCallbacks();
    }
  }, {
    key: "error",
    get: function get() {
      return this._error;
    },
    set: function set(newError) {
      this._error = newError;
      this._callErrorCallbacks();
    }
  }, {
    key: "messages",
    get: function get() {
      return this._messages;
    },
    set: function set(newMessages) {
      this._messages = _toConsumableArray(newMessages);
      this._callMessagesCallbacks();
    }
  }]);
  return ChatState;
}();
export var Chat = /*#__PURE__*/function (_AbstractChat) {
  _inherits(Chat, _AbstractChat);
  var _super = _createSuper(Chat);
  function Chat(_ref) {
    var _this2;
    var messages = _ref.messages,
      agentId = _ref.agentId,
      init = _objectWithoutProperties(_ref, _excluded);
    _classCallCheck(this, Chat);
    var state = new ChatState(agentId, messages);
    _this2 = _super.call(this, _objectSpread(_objectSpread({}, init), {}, {
      state: state
    }));
    _defineProperty(_assertThisInitialized(_this2), "_state", void 0);
    _defineProperty(_assertThisInitialized(_this2), '~registerMessagesCallback', function (onChange) {
      return _this2._state['~registerMessagesCallback'](onChange);
    });
    _defineProperty(_assertThisInitialized(_this2), '~registerStatusCallback', function (onChange) {
      return _this2._state['~registerStatusCallback'](onChange);
    });
    _defineProperty(_assertThisInitialized(_this2), '~registerErrorCallback', function (onChange) {
      return _this2._state['~registerErrorCallback'](onChange);
    });
    _this2._state = state;
    return _this2;
  }
  return _createClass(Chat);
}(AbstractChat);